var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1326 19.9869C17.0732 20.8067 17.3636 21.5985 17.9391 22.1751C18.4719 22.7071 19.1797 23.0001 19.9326 23.0001C20.6858 23.0001 21.3932 22.7071 21.9252 22.1751C22.4584 21.6427 22.7522 20.9345 22.7522 20.182C22.7522 19.4296 22.4584 18.7217 21.9252 18.189C21.3531 17.6165 20.5587 17.3242 19.7371 17.3813L7.0777 6.92825C6.96502 6.83524 6.79978 6.8428 6.69655 6.9464C6.59295 7.05001 6.58501 7.21487 6.6784 7.32755L17.1326 19.9869ZM17.707 19.9291C17.7157 19.8523 17.693 19.7755 17.6438 19.7162L9.00685 9.25746L19.4652 17.8929C19.5249 17.9421 19.6009 17.9647 19.6777 17.956C19.765 17.9462 19.8528 17.9413 19.9405 17.9413C20.544 17.9413 21.1062 18.172 21.5237 18.5901C21.9498 19.0159 22.1846 19.5816 22.1846 20.1824C22.1846 20.7832 21.9498 21.3489 21.5241 21.7743C21.0994 22.1993 20.5341 22.4333 19.9326 22.4333C19.331 22.4333 18.7657 22.1993 18.3403 21.7743C17.859 21.2922 17.6283 20.6191 17.707 19.9291Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8293 19.0821C18.2235 19.6883 18.2235 20.6755 18.8296 21.282C19.1231 21.5762 19.5137 21.738 19.9303 21.738C20.347 21.738 20.738 21.5758 21.0326 21.282C21.6387 20.6752 21.6387 19.6883 21.0329 19.0818C20.738 18.7872 20.3466 18.625 19.9303 18.625C19.514 18.625 19.1231 18.7872 18.8293 19.0821ZM19.2316 19.4826C19.418 19.2946 19.6664 19.1918 19.9307 19.1918C20.1954 19.1918 20.4442 19.295 20.6317 19.4826C21.017 19.8683 21.017 20.4955 20.6317 20.8812C20.2578 21.2544 19.6044 21.2552 19.2316 20.8812C18.8459 20.4955 18.8459 19.8683 19.2316 19.4826Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.625L33.125 9.25L36.7501 16.2501V20.0001H31.75V17.8751L31.25 15.75L28.5 11.625Z",
    fill: "#7BC658"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0172 8.56173C26.4871 8.56173 31.7509 13.8266 31.7509 20.2977C31.7509 20.4543 31.8779 20.5813 32.0345 20.5813H37.0317C37.1882 20.5813 37.3153 20.4543 37.3153 20.2977C37.3153 10.7597 29.5555 3 20.0172 3C15.8722 3 11.8581 4.4981 8.71484 7.21866L9.08578 7.64744C12.1262 5.01612 16.0083 3.56718 20.0172 3.56718C29.1483 3.56718 36.5942 10.9189 36.7458 20.0142H32.315C32.1638 13.3604 26.7053 7.99455 20.0172 7.99455C17.334 7.99455 14.7734 8.85893 12.6117 10.4943L12.9539 10.9465C15.0158 9.3864 17.4584 8.56173 20.0172 8.56173Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98717 9.81641H6.37109V10.3836H7.98717V9.81641Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71046 11.8516H4.99609V12.4187H9.71046V11.8516Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3806 12.8711H4.48047V13.4383H10.3806V12.8711Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71788 13.8887H4.04688V14.4558H9.71788V13.8887Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16478 14.9082H3.70703V15.4754H9.16478V14.9082Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84883 10.834H5.625V11.4012H8.84883V10.834Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72938 15.9258H3.44141V16.493H8.72938V15.9258Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39593 16.9453H3.24219V17.5125H8.39593V16.9453Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17048 17.9629H3.10938V18.5301H8.17048V17.9629Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04131 18.9805H3.03125V19.5476H8.04131V18.9805Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99644 20H3V20.5672H7.99644V20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.1097f1c7e98682c9030581f46add0d2b.svg";
export { ForwardRef as ReactComponent };